import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { BigCta } from "components/big-cta";
import { Button } from "components/button";
import { Footer } from "components/footer";
import { NavBar } from "components/navbar";
import { AffiliateProgramBanner, AffiliatePrograms } from "containers/affiliate-programs";
import { MainContainer } from "containers/main-container";
import { Video2 } from "containers/video2";
import useHelper from "helpers";
import { Meta } from "seo/meta";
import { Banner2 } from "styles/banners";
import { TextHeadingOne, ParagraphText } from "styles/typography";
import { IntroWrapper } from "styles/wrappers";

export default function AffiliateProgram() {
   const { handleCta } = useHelper();

   return (
      <Meta
         title="Affiliate Program"
         description="Earn 20% lifetime commission for every referral.
      "
      >
         <NavBar />
         <Banner2>
            <TextHeadingOne mw="738" center>
               Promote Metricks and get a 20% Commission
            </TextHeadingOne>
            <ParagraphText center>
               Make Extra Income Through The Metricks Affiliate Program!
            </ParagraphText>
            <br />
            <Button variant="primary" onClick={handleCta} size="regular" width="190" style={{cursor: "pointer", zIndex: 10}}>
               Join Now
            </Button>
         </Banner2>
         <MainContainer>
            <AffiliateProgramBanner />

            <br />
            <br />
            <br />

            <Video2 />

            <IntroWrapper>
               <TextHeadingOne center mw="1000" style={{ fontSize: 36 }}>
                  Why Should You Jump At This?
               </TextHeadingOne>
            </IntroWrapper>

            <AffiliatePrograms />
            <BigCta />
         </MainContainer>
         <Footer />
      </Meta>
   );
}

export const getServerSideProps = async ({ locale }) => ({
   props: {
      ...(await serverSideTranslations(locale, ["common"])),
   },
});
